import Storage from '../Utils/Storage';

export const storage = new Storage();
